import React from 'react';
import styled from 'styled-components';

export default ({checked, onChange}) => <Styled className="material-icons" checked={checked} onClick={() => onChange(!checked)}>{checked ? "check_box" : "check_box_outline_blank"}</Styled>;

const Styled = styled.span`
  cursor: pointer;
`;